"use client"

import styled from "@emotion/styled"
import { Button } from "@mui/material"
import Container from "ui/Container"
import { sharedColors } from "ui/theme/colors"
import { getNonUmbracoUrl, Link } from "utils"
import { extractProperty } from "utils/extractProperty"
import { getUmbracoMediaUrl } from "utils/getUmbracoMediaUrl"
import { AccentPalette, getBlockAccentPalette } from "./accentPalette"

const OuterContainer = styled.div<{ $isGray?: boolean }>`
  width: 100%;
  background-color: ${({ $isGray }) =>
    $isGray ? sharedColors.mediumGrayLight : "transparent"};
`

const StyledContainer = styled.div<{ isLast?: boolean }>`
  width: 100%;
  padding-bottom: 48px;
  ${({ theme }) => theme.breakpoints.down("md")} {
    display: flex;
    justify-content: center;
  }
  ${({ theme, isLast }) => theme.breakpoints.up("md")} {
    padding-bottom: ${({ isLast }) => (isLast ? "84px" : "48px")};
  }
`
const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "$accent",
})<{ target?: string; $accent?: AccentPalette }>`
  width: 218px;
  ${({ $accent }) =>
    $accent &&
    `
    border-color: transparent;
    background:
      linear-gradient(${sharedColors.white}, ${sharedColors.white}) padding-box,
      ${$accent.fill} border-box;
    color: ${sharedColors.black};
    :hover,
    :focus-visible {
      background: ${$accent.hover};
      color: ${$accent.contrastText};
    }
    :active {
      background: ${$accent.active};
    }
    :disabled {
      border-color: transparent;
    }
  `}
`

type Props = {
  data: any
  isLast?: boolean
  blockIndex?: number
  isHomepage?: boolean
}

export default function ButtonComp({
  data,
  isLast = true,
  blockIndex,
  isHomepage,
}: Props) {
  const accent = getBlockAccentPalette(data)
  const buttonName = extractProperty(data, "button")?.[0]?.name
  const buttonUrl = extractProperty(data, "button")?.[0]?.url
  const target = extractProperty(data, "button")?.[0]?.target
  // Media links keep the media host rewrite; content links must drop the
  // internal Umbraco "/pages" route prefix
  const buttonHref = buttonUrl?.includes("/media/")
    ? getUmbracoMediaUrl(buttonUrl)
    : getNonUmbracoUrl(buttonUrl)
  const isGray =
    isHomepage && typeof blockIndex === "number" && blockIndex % 2 === 1
  return (
    <OuterContainer $isGray={isGray}>
      <Container paddingMobile={true}>
        {buttonUrl && (
          <StyledContainer isLast={isLast}>
            <StyledButton
              variant="secondary"
              LinkComponent={Link}
              href={buttonHref}
              target={target}
              $accent={accent}
            >
              {buttonName}
            </StyledButton>
          </StyledContainer>
        )}
      </Container>
    </OuterContainer>
  )
}
